<template>
  <div class="modal-container">
    <transition name="modal" :duration="duration">
      <div v-show="show" class="modal-container">
        <div class="modal" @click.self="clickMask">
          <div class="core-modal-dialog">
            <div class="core-modal-content" :style="{ width: width }">
              <div class="core-modal-header">
                {{ title }}

                <Close :size="24" v-if="closeIconShown" @click.prevent="cancel" />
              </div>

              <slot></slot>
            </div>
          </div>
        </div>

        <div class="modal-backdrop"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import Close from 'icons/Close'

export default {
  name: 'Modal',
  components: {
    Close,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    force: {
      type: Boolean,
      default: false
    },
    closeIconShown: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: 'auto'
    },
  },
  data() {
    return {
      show: false,
      duration: 500
    }
  },
  created() {
    if (this.show) {
      document.body.className += ' modal-open'
    }
  },
  beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, '')
  },
  watch: {
    show(value) {
      if (value) {
        document.body.className += ' modal-open'
      } else {
        window.setTimeout(() => {
          document.body.className = document.body.className.replace(/\s?modal-open/, '')
        }, this.duration)
      }
    }
  },
  methods: {
    listenKeyUp(event) {
      if (event.key === 'Escape') {
        this.cancel()
      }
    },
    ok() {
      this.$emit('ok')
      this.show = false
      window.removeEventListener('keyup', this.listenKeyUp)
    },
    cancel() {
      this.$emit('cancel')
      this.$emit('closeEvent', true)
      this.show = false
      window.removeEventListener('keyup', this.listenKeyUp)
    },
    clickMask() {
      if (!this.force) {
        this.cancel()
      }
    },
    open() {
      this.show = true
      document.body.className += ' modal-open'
      window.addEventListener('keyup', this.listenKeyUp)
    },
    close() {
      this.show = false
      this.$emit('closeEvent', true)
      window.removeEventListener('keyup', this.listenKeyUp)
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-container {
  .modal {
    display: block;
  }

  .core-modal-dialog,
  .modal-backdrop {
    transition: all .5s ease;
  }

  .modal-enter .core-modal-dialog,
  .modal-leave-active .core-modal-dialog {
    opacity: 0;
    transform: translateY(-30%);
  }

  .modal-enter .modal-backdrop,
  .modal-leave-active .modal-backdrop {
    opacity: 0;
  }

  .modal-backdrop {
    opacity: 0.5;
  }

  .core-modal-dialog {
    margin: 2rem auto;
    display: flex;
    justify-content: center;
  }

  .core-modal-content {
    pointer-events: auto;
    padding: 2rem;
    border: 1px solid #cdcdcd;
    border-radius: 15px;
    background: #FFF;

    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .core-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;

    font-size: 1.5rem;
    font-weight: 700;
    line-height: 32.74px;
    color: #202224;

    span {
      cursor: pointer;
    }
  }

  .close-modal {
    margin-left: 1rem;
    font-size: $font-size-large;
    line-height: $font-size-large;
    cursor: pointer;
  }
}
</style>